import { Component } from '@angular/core';

@Component({
  selector: 'zdb-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
}
